<script lang="ts">
	import { onMount } from "svelte";
	import { inflectDays, inflectHours, inflectMinutes } from "@core/utils/inflect.js";
	import { DateTime, type DurationObjectUnits } from "@core/utils/luxon.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { target }: { target: string } = $props();

	const targetTime = DateTime.fromISO(target);
	const { tenant } = getGlobalTemplateProps();

	function getTimeLeft(): DurationObjectUnits {
		return targetTime.diffNow(["days", "hours", "minutes"]).toObject();
	}

	let timeLeft = $state(getTimeLeft());

	function update(): void {
		timeLeft = getTimeLeft();
	}

	onMount(() => {
		const interval = setInterval(() => {
			update();
		}, 1000);

		return (): void => {
			clearInterval(interval);
		};
	});

	const digitGroups = $derived.by(() => {
		const groups: [string, number[]][] = [];
		if (timeLeft.days !== undefined) {
			groups.push([
				inflectDays[tenant.locale](timeLeft.days),
				String(Math.round(timeLeft.days)).toString().padStart(2, "0").split("").map(Number),
			]);
		}
		if (timeLeft.hours !== undefined) {
			groups.push([
				inflectHours[tenant.locale](timeLeft.hours),
				String(Math.round(timeLeft.hours)).toString().padStart(2, "0").split("").map(Number),
			]);
		}
		if (timeLeft.minutes !== undefined) {
			groups.push([
				inflectMinutes[tenant.locale](timeLeft.minutes),
				String(Math.round(timeLeft.minutes)).toString().padStart(2, "0").split("").map(Number),
			]);
		}
		return groups;
	});
</script>

<div class="flex gap-3 lg:gap-6">
	{#each digitGroups as [name, digits], index (index)}
		<div class="flex flex-col items-center gap-1 lg:gap-2">
			<div class="flex gap-1 lg:gap-2">
				{#each digits as digit, index (index)}
					<span
						class="bg-black shadow-sm border-white border-2 text-4xl lg:text-6xl/snug p-2.5 rounded-lg font-bold text-white min-w-12 lg:min-w-16 xl:min-w-20 text-center"
						>{digit}</span
					>
				{/each}
			</div>
			<span class="text-grey-700 font-semibold">{name}</span>
		</div>
	{/each}
</div>
